module.exports = "/static/assets/27f90bfa982840e56c3ad207561193fa.svg";